import React from 'react';
import logInRoute from '@routes/LogIn';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import UserTypeGate, { USER_TYPE_IDS } from '@components/UserTypeGate';
import StudentHome from '@routes/StudentHome';
import HomeIndex from '@routes/Home/routes/HomeIndex';
import AdminPortal from '@routes/Home/routes/AdminPortal';
import { NAME, reducer } from '@routes/Home/modules/Module';
import Downloads from '@routes/Home/routes/Downloads';
import Campus from './routes/Campus';
import Curriculum from './routes/Curriculum';
import StudentProfile from './routes/StudentProfile';
import StudentHandoff from '@routes/StudentHandoff';

const LazyHomeLogIn = React.lazy(
	() => import(/* webpackChunkName : 'Home' */ './components/Home')
);

export default (store) => {
	store.injectReducer(NAME, reducer);
	return [
		{
			path: '/',
			element: (
				<AsyncLoading
					component={
						<UserTypeGate expectedTypeId={USER_TYPE_IDS.STAFF}>
							<LazyHomeLogIn />
						</UserTypeGate>
					}
				/>
			),
			children: [
				HomeIndex(store),
				Campus(store),
				AdminPortal(store),
				// Curriculum(store),
				StudentProfile(),
				Downloads(),
			],
		},
		StudentHandoff(),
		StudentHome(),
		logInRoute(),
	];
};
